// @flow
import React, {Fragment} from 'react';
import {FormattedMessage} from 'react-intl';
import gql from 'graphql-tag';

import './PinnedProperty.less';

export const fragments = {
    PinnedPropertyHit: gql`
        fragment PinnedPropertyHit on SERPHit {
            available
            pinned
        }
    `
};
export type SERPHitShape = {
    available: boolean,
    pinned: boolean
};

type Props = {
    children: any,
    available: boolean,
    numResults: number
};

const getTitle = (linguaId: string, available: boolean) => {
    return available ? (
        <FormattedMessage
            id={linguaId}
            description="Pinned property label"
            defaultMessage="Featured property"
        />
    ) : (
        <FormattedMessage
            id="pinnedPropertyUnavailable"
            description="Pinned property unavailable label"
            defaultMessage="This featured property is unavailable on your dates"
        />
    );
};

const getNearbyPropertiesTitle = () => {
    return (
        <h2 className="HitCollection_nearbyTitle">
            <FormattedMessage
                id="expandedSearchNearbyLabel"
                description="Nearby property label"
                defaultMessage="You might like these nearby properties"
            />
        </h2>
    );
};

const PinnedProperty = ({available, children, numResults}: Props) => {
    const nearbyProperties = numResults > 1;

    return (
        <Fragment>
            <div className="PinnedProperty">
                <div className="bg--color-brand PinnedContainer--container">
                    <h4>{getTitle('pinnedPropertyAlt', available)}</h4>
                    {children}
                </div>
            </div>
            {!available && nearbyProperties && getNearbyPropertiesTitle()}
        </Fragment>
    );
};

export default PinnedProperty;
